import { Box, Typography, Link } from "@mui/material"
import { ReactElement } from "react"

import MfaHelpCard from "./mfaHelpCard"
import AppStores from "../../../assets/images/app-stores.png"
import AuthExample from "../../../assets/images/mfa-example.png"
import QRCodeExample from "../../../assets/images/qr-code.png"
import { CONNECT_DIRECT_SUPPORT_EMAIL } from "../../../errors/errorMessages"

const FONT_WEIGHT = 300

const MfaHelpSteps = (): ReactElement => (
    <Box>
        <Typography fontWeight={FONT_WEIGHT}>
            To access Connect Direct you will need to set up your access to MFA.
            To do this follow these steps:
        </Typography>
        <br />
        <Box display="flex" flexDirection="row" gap={2} alignItems="stretch">
            <Box flex={1}>
                <MfaHelpCard
                    title="Step 1"
                    helpTxt="Download the authenticator app on your phone, such as Google or Microsoft Authenticator free of charge"
                    imgSrc={AppStores}
                    altText="Get Authenticator App"
                />
            </Box>
            <Box flex={1}>
                <MfaHelpCard
                    title="Step 2"
                    helpTxt="Open the app and scan the QR code displayed on MFA screen"
                    imgSrc={QRCodeExample}
                    altText="Scan QR Code"
                />
            </Box>
            <Box flex={1}>
                <MfaHelpCard
                    title="Step 3"
                    helpTxt="The App will produce a code and is shown in the ConnectDirect profile example shown below."
                    imgSrc={AuthExample}
                    altText="MFA Code Example"
                />
            </Box>
        </Box>
        <br />
        <Typography fontWeight={FONT_WEIGHT}>
            Once you are shown the code, you can enter this onto the website to
            enter the portal.
        </Typography>
        <br />
        If you unable to log in, please contact{" "}
        <Link href={`mailto:${CONNECT_DIRECT_SUPPORT_EMAIL}`} target="_blank">
            {CONNECT_DIRECT_SUPPORT_EMAIL}
        </Link>{" "}
        for support.
    </Box>
)

export default MfaHelpSteps
